import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  flow: defineAsyncComponent(() => import("/app/layouts/flow.vue").then(m => m.default || m))
}